import { render, staticRenderFns } from "./model5.vue?vue&type=template&id=fb8b30fa&scoped=true"
import script from "./model5.vue?vue&type=script&lang=js"
export * from "./model5.vue?vue&type=script&lang=js"
import style0 from "./model5.vue?vue&type=style&index=0&id=fb8b30fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8b30fa",
  null
  
)

export default component.exports